var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compras"},[_c('navigation'),_c('compras')],1)}
var staticRenderFns = []

export { render, staticRenderFns }